import Types from '../Types';
import Immutable from 'seamless-immutable';
import { createReducer } from 'reduxsauce';
import _get from 'lodash.get';

export const INITIAL_STATE = Immutable({
  error: null,
  findAttempting: false, companies: [], pageCount: 0,
  optionsAttempting: false, companyOptions: []
});

const ACTION_HANDLERS = {
  [Types.FIND_COMPANIES_ATTEMPT]: (state, action) =>
    state.merge({ findAttempting: true }),
  [Types.FIND_COMPANIES_SUCCESS]: (state, action) =>
    state.merge({
      findAttempting: false,
      companies: _get(action, ['result', 'companies']) || [],
      pageCount: _get(action, ['result', 'pageCount']) || 0,
      error: null
    }),
  [Types.FIND_COMPANIES_FAILURE]: (state, action) =>
    state.merge({ findAttempting: false, error: action.error }),

  [Types.FIND_COMPANY_OPTIONS_ATTEMPT]: (state, action) =>
    state.merge({ optionsAttempting: true }),
  [Types.FIND_COMPANY_OPTIONS_SUCCESS]: (state, action) =>
    state.merge({
      optionsAttempting: false,
      companyOptions: action.result || [],
      error: null
    }),
  [Types.FIND_COMPANIES_FAILURE]: (state, action) =>
    state.merge({
      optionsAttempting: false,
      error: action.error
    })
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/redux/company/companyReducer.js